import {
    deleteMethodCustomHeader,
    getMethodCustomHeader,
    postMethodCustomHeader,
} from '../../Utils/response'
import { GetUserProfileAction } from './ProfileAction'

export const GET_ADDRESSES_REQUEST = 'GET_ADDRESSES_REQUEST'
export const GET_ADDRESSES_SUCCESS = 'GET_ADDRESSES_SUCCESS'
export const GET_ADDRESSES_FAILURE = 'GET_ADDRESSES_FAILURE'

export const ADD_ADDRESS_REQUEST = 'ADD_ADDRESS_REQUEST'
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS'
export const ADD_ADDRESS_FAILURE = 'ADD_ADDRESS_FAILURE'

export const DELETE_ADDRESS_REQUEST = 'DELETE_ADDRESS_REQUEST'
export const DELETE_ADDRESS_SUCCESS = 'DELETE_ADDRESS_SUCCESS'
export const DELETE_ADDRESS_FAILURE = 'DELETE_ADDRESS_FAILURE'

export const UPDATE_ADDRESS_REQUEST = 'UPDATE_ADDRESS_REQUEST'
export const UPDATE_ADDRESS_SUCCESS = 'UPDATE_ADDRESS_SUCCESS'
export const UPDATE_ADDRESS_FAILURE = 'UPDATE_ADDRESS_FAILURE'

// GET addresses
export const getAddresses = (setAlert) => async (dispatch) => {
    dispatch({ type: GET_ADDRESSES_REQUEST })
    try {
        const token = localStorage.getItem('userToken')
        const res = await getMethodCustomHeader(`user/address`, {
            headers: { Authorization: `Bearer ${token}` },
        })
        dispatch({ type: GET_ADDRESSES_SUCCESS, payload: res.data.data })
    } catch (error) {
        dispatch({ type: GET_ADDRESSES_FAILURE, payload: error })
        setAlert && setAlert('Failed to fetch addresses', 'error')
    }
}

// ADD address
export const addAddress = (data, setAlert) => async (dispatch) => {
    dispatch({ type: ADD_ADDRESS_REQUEST })
    try {
        const token = localStorage.getItem('userToken')
        const res = await postMethodCustomHeader(`user/address`, data, {
            headers: { Authorization: `Bearer ${token}` },
        })
        dispatch({ type: ADD_ADDRESS_SUCCESS, payload: res.data.data })

        dispatch(GetUserProfileAction(setAlert))
        setAlert && setAlert('Address added successfully', 'success')
    } catch (error) {
        dispatch({ type: ADD_ADDRESS_FAILURE, payload: error })
        setAlert && setAlert('Failed to add address', 'error')
    }
}

// DELETE address
export const deleteAddress = (id, setAlert) => async (dispatch) => {
    dispatch({ type: DELETE_ADDRESS_REQUEST })
    try {
        const token = localStorage.getItem('userToken')
        await deleteMethodCustomHeader(`user/address/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
        dispatch({ type: DELETE_ADDRESS_SUCCESS, payload: id })
        setAlert && setAlert('Address deleted successfully', 'success')
    } catch (error) {
        dispatch({ type: DELETE_ADDRESS_FAILURE, payload: error })
        setAlert && setAlert('Failed to delete address', 'error')
    }
}

export const updateAddress = (id, data, setAlert) => async (dispatch) => {
    dispatch({ type: UPDATE_ADDRESS_REQUEST })
    try {
        const token = localStorage.getItem('userToken')
        const res = await postMethodCustomHeader(`user/address/${id}`, data, {
            headers: { Authorization: `Bearer ${token}` },
        })
        dispatch({ type: UPDATE_ADDRESS_SUCCESS, payload: res.data.data })
        setAlert && setAlert('Address updated successfully', 'success')
    } catch (error) {
        dispatch({ type: UPDATE_ADDRESS_FAILURE, payload: error })
        setAlert && setAlert('Failed to update address', 'error')
    }
}
